import React, { Component } from 'react';
/* eslint-disable */

import { withRouter } from 'react-router-dom';

class Logout extends Component {
	componentDidMount() {
		console.log('Logout');
		localStorage.clear();
		this.props.history.push('/');
	}

	render() {
		return <div></div>;
	}
}

export default withRouter(Logout);
